function parseAkamaiHeader(headerString, {
  delimiter
}) {
  return headerString.split(delimiter).map(pair => pair.split('=')).reduce((acc, val) => {
    const key = val[0].trim();
    acc[key] = val[1].trim();
    return acc;
  }, {});
}

export { parseAkamaiHeader };
